import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import ConfigMock from "../../../public/mockup/config.json";
import { languageOptions, live_sites, statesOptions } from '../../../../../core/form-engine/projects/form-engine/src/services/data-entry.configuration';
import { countryOptions } from '../../../../../core/form-engine/projects/form-engine/src/services/data-entry.configuration';
import { PhoneNumberService } from './phonenumber.service';
import { prefixes_lists } from '../modules/user-profile/jsons/user-account-configs';
import { ToastObject } from '../interfaces/toast-object';
import { BehaviorSubject } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  configurations: any = ConfigMock;
  private _showToastMessage: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public toastMessage$ = this._showToastMessage.asObservable();

  constructor(private router: Router,
    private phoneNumberService: PhoneNumberService,
    private configService: ConfigService) {
  }
  // /**
  //  * Navigate to path
  //  * @param path 
  //  */
  // navigate(path: any) {
  //   this.router.navigate([path]);
  // }

  /**
   * Get Number of Days difference
   * @param timestamp 
   * @returns 
   */
  getDaysAgo(timestamp: any) {
    const currentDate: any = new Date();
    const givenDate: any = new Date(timestamp); // Convert millisecond timestamp to Date
    // Calculate the difference in milliseconds
    const differenceInMs = currentDate - givenDate;
    // Convert milliseconds to days
    const differenceInDays = Math.floor(differenceInMs / (1000 * 60 * 60 * 24));
    return differenceInDays;
  }
  /**
   * Truncate text by given number of characters
   * @param text 
   * @param truncateAfterChars 
   * @returns 
   */
  truncateText(text: any, truncateAfterChars: number) {
    return text && text.length > truncateAfterChars ? text.substring(0, truncateAfterChars) + '...' : text;
  }
  /**
   * Get Date in DD/MM/YY(type 1) or DD/MM/YYYY HH:MM:SS(type 2) format from given timestamp
   * @param timestamp 
   * @returns 
   */
  getDateFromTimestamp(timestamp: any, type = 1) {
    const date = new Date(timestamp);
    let finalDate = ""
    if (type === 1) {
      const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const year = String(date.getFullYear()).slice(-2); // Get last two digits of the year
      finalDate = `${day}/${month}/${year}`; // Formatted as DD/MM/YY
    } else if (type === 2) {
      const formattedDate = date.toLocaleDateString('en-GB'); // DD/MM/YYYY format
      const formattedTime = date.toLocaleTimeString('en-GB'); // HH:MM:SS format
      finalDate = `${formattedDate} ${formattedTime}`; // combine both date and time
    }
    return finalDate;
  }
  /**
   * Get country description using code
   * @param code 
   * @returns 
   */
  getCountryDescription(code: string) {
    if (!code) {
      return;
    }
    return ((this.configurations.countries[code.toLowerCase()] && this.configurations.countries[code.toLowerCase()].label) || code);
  };
  /**
   * Get language from local
   * @param locale 
   * @returns 
   */
  getLanguageDescription(locale: string) {
    locale = locale?.toLowerCase();
    let foundLabel: string = "";
    languageOptions.forEach(
      (language: any) => {
        if (language.value === locale) {
          foundLabel = language.label;
        }
      }
    );
    const obj = foundLabel ? foundLabel : locale;
    return obj;
  }

  /**
   * Used to parse emergency contact
   * @param emergencyContacts 
   * @returns
   */
  parseEmergencyContact(emergencyContacts: any) {
    if (emergencyContacts) {
      try {
        return PhoneNumberService.parseEmergencyContacts(emergencyContacts);
      } catch (err) {
        return null;
      }
    }
  };

  /**
   * Used to get the all the phone number prefixes
   * @returns list of phone number prefix
   */
  public getPhoneNumberPrefix() {
    const prefixlist: any = prefixes_lists;
    const prefixOptions = prefixlist ? Object.keys(prefixes_lists).map((prefixKey: string) => {
      return {
        value: prefixlist[prefixKey].value,
        label: prefixlist[prefixKey].label
      }
    }) : {};
    return prefixOptions;
  }

  /**
   * Used to show the toast message
   * @param toastObject
   */
  showToastMessage(toastObject: ToastObject) {
    this._showToastMessage.next(toastObject);
  }

  getCountryOptions() {
    const backofficeConfig = this.configService.getBackOfficeConfig()['BACKOFFICE_CONFIG'] as any;
    const region = backofficeConfig['REGION']?.toLowerCase();
    const live_countries = live_sites?.live_countries ?? {}
    const liveCountriesOptions = countryOptions[region]
      ?.map((countryObj: any) => ({ ...countryObj, value: countryObj.value.toUpperCase() }))
      .filter((opt: any) => Object.keys(live_countries).includes(opt.value.toUpperCase()))
    return liveCountriesOptions;
  }

  getStateOptions(countryCode: any) {
    const states = statesOptions?.[countryCode?.toLowerCase()]?.map((state: any) => ({ value: state.code, label: state.label }));
    return states;
  }

  getBillingAddressStateOptions(countryCode: any) {
    const states = statesOptions?.[countryCode?.toLowerCase()]?.map((state: any) => ({ value: state.label, label: state.label }));
    return states;
  }

  /**
   * scroll to top of the page
   */
  scrollToTop() {
    const el = document.getElementById('fleet-portal');

    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  }

}
